import { translateBackend } from '@assets/i18n/config';
import { Grid } from '@ovComponents/1-primative/grid/grid';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import { TextField } from '@ovComponents/2-component/textField/textField';
import { FieldRequiredType } from '@ovComponents/4-module/configurableOptionFields/basicField';
import { WorkflowCompletionForm } from '@ovComponents/4-module/workflowCompletion/components/workflowCompletionForm';
import { kebabCase } from 'lodash-es';
import { type Dispatch, type SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { invalidFields } from '../utils';

export const SimpleForm = ({
  options,
  onNext,
  data,
  onChangeSetData,
  stepLoading = false,
}: {
  options: any;
  onNext: any;
  data: any;
  onChangeSetData: Dispatch<SetStateAction<any>>;
  stepLoading?: boolean;
}) => {
  const { t } = useTranslation('workflowCompletions');
  const [focused, setFocused] = useState<string[]>([]);

  const submit = async () => {
    const errors = invalidFields(options, data);
    if (errors.length === 0) {
      await onNext();
    }
  };
  const errors = invalidFields(options, data);

  return (
    <WorkflowCompletionForm
      onSubmit={submit}
      submitButtonProps={{
        label: t('continue'),
        disabled: errors.length > 0 || stepLoading,
        dataTestId: 'simple-form-continue-button',
      }}
    >
      <Typography variant='displayLarge' sx={{ mt: 1 }}>
        {translateBackend(options?.title)}
      </Typography>
      <Typography variant='bodyLarge' sx={{ mb: 3 }}>
        {translateBackend(options?.subtitle)}
      </Typography>
      <Grid container spacing={2}>
        {Object.keys(options)?.map(
          (key) =>
            options[key].enabled && (
              <Grid key={key} item xs={12} md={12}>
                <TextField
                  testId={`simple-form-${kebabCase(key)}`}
                  label={translateBackend(options[key].label)}
                  onChange={(e: any) =>
                    onChangeSetData((prev: any) => ({
                      ...prev,
                      [key]: e.target.value,
                    }))
                  }
                  value={data[key] ?? ''}
                  onBlur={() => setFocused([...focused, key])}
                  error={
                    !data[key] &&
                    focused.includes(key) &&
                    options[key]?.required !== FieldRequiredType.NOT_REQUIRED
                  }
                  fullWidth
                  sx={{ mb: 2 }}
                  disabled={stepLoading}
                />
              </Grid>
            ),
        )}
      </Grid>
    </WorkflowCompletionForm>
  );
};

export default SimpleForm;
